import type { ReactNode } from "react";

import { t } from "../../lib/i18n";

import "./ui.css";

export interface DescriptionItem {
  labelKey: string;
  value: ReactNode;
}

interface DescriptionListProps {
  items: DescriptionItem[];
  columns?: 1 | 2 | 3;
}

export function DescriptionList({ items, columns = 2 }: DescriptionListProps) {
  return (
    <dl className={`description-list description-list--cols-${columns}`}>
      {items.map((item) => (
        <div className="description-list__row" key={item.labelKey}>
          <dt className="description-list__label">{t(item.labelKey)}</dt>
          <dd className="description-list__value">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
